import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { AxiosContext } from "contexts/AxiosContext";
import { UserProfile } from "interfaces/userProfile";

const STALE_TIME = 1000 * 60 * 5;

export const useUserProfileQuery = (
  userId: number
): UseQueryResult<UserProfile, unknown> => {
  const { axios } = useContext(AxiosContext)!;

  return useQuery({
    queryKey: ["/settings/user_profile", userId],
    queryFn: async () => {
      const { data } = await axios.get<UserProfile>(
        `/settings/user_profile/${userId}`
      );

      return data;
    },
    staleTime: STALE_TIME
  });
};
